import React, { createContext, useContext, useState } from 'react';

const DemoTourContext = createContext();

export const useDemoTour = () => {
  const context = useContext(DemoTourContext);
  if (!context) {
    throw new Error('useDemoTour must be used within DemoTourProvider');
  }
  return context;
};

export const DemoTourProvider = ({ children }) => {
  const [tourActive, setTourActive] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const tourSteps = {
    apprentice: [
      { title: 'Complete Profile', path: '/apprentice/profile', description: 'Fill in your personal information' },
      { title: 'Make Payment', path: '/apprentice/payment', description: 'Pay €500 to unlock assessments' },
      { title: 'Take Assessments', path: '/apprentice/assessments', description: 'Complete 3 assessments' },
      { title: 'Generate CV', path: '/apprentice/cv', description: 'Build your AI-powered CV' },
      { title: 'View Matches', path: '/apprentice/matches', description: 'See your matched employers' }
    ],
    employer: [
      { title: 'Subscribe', path: '/employer/billing', description: 'Choose your subscription plan' },
      { title: 'Post a Role', path: '/employer/post-role', description: 'Create your first apprenticeship role' },
      { title: 'View Candidates', path: '/employer/candidates', description: 'See eligible candidates' },
      { title: 'Invite Candidate', path: '/employer/candidates', description: 'Send interview invitation' }
    ],
    admin: [
      { title: 'View Analytics', path: '/admin/overview', description: 'Check platform metrics' },
      { title: 'Adjust Weights', path: '/admin/matching-weights', description: 'Modify matching algorithm' },
      { title: 'See Updated Matches', path: '/admin/overview', description: 'Observe match recalculation' }
    ]
  };

  const startTour = (role) => {
    setTourActive(true);
    setCurrentStep(0);
  };

  const endTour = () => {
    setTourActive(false);
    setCurrentStep(0);
  };

  const nextStep = () => {
    setCurrentStep(prev => prev + 1);
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(0, prev - 1));
  };

  return (
    <DemoTourContext.Provider value={{
      tourActive,
      currentStep,
      tourSteps,
      startTour,
      endTour,
      nextStep,
      prevStep
    }}>
      {children}
    </DemoTourContext.Provider>
  );
};
